import { Box, Flex } from '@rebass/grid/emotion'
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface FormFooterProps {
  submitDisabled?: boolean
  submitText?: string | any
  cancelText?: string | any
  onSubmitClick: () => void
  onCancelClick: () => void
}

export const FormFooter: React.FunctionComponent<FormFooterProps> = (props) => {
  const { t } = useTranslation()

  return (
    <Flex justifyContent="flex-end">
      <Box px={1}>
        <DefaultButton onClick={props.onCancelClick}>
          {props.cancelText || t('action.cancel')}
        </DefaultButton>
      </Box>
      <Box px={1}>
        <PrimaryButton
          onClick={props.onSubmitClick}
          disabled={props.submitDisabled}
        >
          {props.submitText || t('action.save')}
        </PrimaryButton>
      </Box>
    </Flex>
  )
}

export default FormFooter
